import React from 'react';
import { observer } from 'mobx-react';
import {WeaTextarea } from 'ecCom';

interface Props {
    value?: string;
    valueSpan?:string;
    viewAttr:string;
    onBlur: (string) => void;
    ecId?:string;
}

export default observer((props: Props) => {
    const { value,onBlur,viewAttr } = props;
    return (
        <div  style={{float:'left'}}>
        <WeaTextarea ecId={`${props && props.ecId || ''}_WeaTextarea@ngj4uq`}
        value={value}
        viewAttr={viewAttr}
        minRows={2}
        maxRows={10}
        onBlur={onBlur}
    />
        </div>
    )
});


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/list/littleCard/table-cell/WeaTextarea.tsx